<!-- Events -->
<!-- itemCreated -->

<template>
  <base-sq-card>
    <template v-slot:heading>
      <span class="tile-card-heading">Addresses</span>
      <v-spacer></v-spacer>
      <base-btn-menu
        icon="mdi-dots-vertical"
      >
        <v-list>
          <v-list-item
            link
            :href="powUrl + '/edit.php?id=' + selectedAccount.external_key"
            :target="'_blank'"
          >
            <v-list-item-title>
              <v-icon
                color="orange"
                class="mr-1"
              >
                mdi-pencil
              </v-icon>

              Edit
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </base-btn-menu>
    </template>
    <v-col
      cols="12"
      class="d-flex"
    >
      <v-row class="d-flex fluid">
        <v-card
          v-for="location of locs"
          :key="location.type"
          style="min-width:280px"
          class="mx-2"
          tile
        >
          <v-toolbar
            elevation="0"
            dense
          >
            <h2>{{ location.type }}</h2>
          </v-toolbar>
          <v-row
            class="mx-2"
          >
            <v-col
              cols="12"
            >
              <v-text-field
                v-model="location.attn"
                label="Attn"
              >
              </v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="location.addr1"
                label="Addr1"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="location.city"
                label="city"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="location.state"
                label="state"
              >
              </v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="location.zip"
                label="zip"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="4"
              md="5"
            >
              <v-text-field
                v-model="location.latitude"
                label="Latitude"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="4"
              md="5"
            >
              <v-text-field
                v-model="location.longitude"
                label="Longitude"
              >
              </v-text-field>
            </v-col>
            <v-col
              cols="3"
              md="1"
              class="d-flex flex-column"
            >
              <v-btn
                fab
                :href="`https://www.google.com/maps/search/?api=1&query=${location.latitude},${location.longitude}`"
                target="_blank"
                color="lime"
                dark
              >
                <v-icon
                  class="my-auto"
                  large
                >
                  mdi-google-maps
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-row>
    </v-col>
    <v-overlay
      :value="overlayDisplay"
      :absolute="overlayAbsolute"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
  </base-sq-card>
</template>

<script>
  // Utilities
  import { mapActions, mapGetters } from 'vuex'
  import {
  } from '../../store/actions.types'
  import basicMixin from '../../mixins/basic'
  export default {
    name: 'AcctCorrespondences',
    components: {
      // PowInvoiceDetails: () => import('@/components/pow/InvoiceDetails'),
    },

    mixins: [basicMixin],
    inheritAttrs: false,

    props: {
    },
    data: function () {
      return {
        totalRecords: 0,
        loading: false,
        options: {},
        items: [],
        currentObject: {},
        snapshotObject: {},
        formMode: '',
        formErrors: [],
        overlayAbsolute: true,
        overlayDisplay: false,
        dlgSendTemplate: false,
        headers: [
          { text: '', value: '_action' },
          { text: 'number', value: 'number' },
          { text: 'type_name', value: 'type_name' },
        ],
      }
    },

    computed: {
      ...mapGetters({
        // items: 'selectedAccountCorrespondences',
        selectedAccount: 'acctSelectedAccount',
      }),
      locs () {
        const locations = []
        for (const type in this.selectedAccount._addresses) {
          const loc = this.selectedAccount._addresses[type]
          loc.type = type
          if (loc.addr1 && loc.addr1.length > 0) {
            locations.push(loc)
          }
        }
        return locations
      },
    },
    watch: {
      options: {
        handler (val, oldVal) {
          console.log('table options changed:', val)
          this.doGetObjects()
        },
        deep: true,
      },
    },
    async created () {
      // this.init()
    },
    async mounted () {
      this.init()
    },
    methods: {
      ...mapActions({
      }),
      async init () {
        console.log(`Initializing ${name} setting values!`, this.item)
        this.formMode = 'read'
      },
      resetForm () {
        this.overlayDisplay = false
        this.currentObject = { ...this.snapshotObject }
        this.formErrors = []
      },
    },

  }
</script>

<style>
</style>
